import { ref } from 'vue';
import type { Router } from 'vue-router';

const FALLBACK_DELAY_MS = 120;

export const showRouteFallback = ref(false);
export const routeContentError = ref<Error | null>(null);

let hooksInstalled = false;
let pendingTimer: ReturnType<typeof setTimeout> | null = null;

function clearPendingTimer() {
  if (pendingTimer) {
    clearTimeout(pendingTimer);
    pendingTimer = null;
  }
}

export function installRouteNavigationState(router: Router) {
  if (hooksInstalled) {
    return;
  }
  hooksInstalled = true;

  router.beforeEach((to, from) => {
    if (to.fullPath === from.fullPath) {
      return;
    }

    clearPendingTimer();
    showRouteFallback.value = false;
    routeContentError.value = null;
    pendingTimer = setTimeout(() => {
      showRouteFallback.value = true;
    }, FALLBACK_DELAY_MS);
  });

  router.afterEach(() => {
    clearPendingTimer();
    showRouteFallback.value = false;
  });

  router.onError((error) => {
    clearPendingTimer();
    showRouteFallback.value = false;
    routeContentError.value = error instanceof Error
      ? error
      : new Error(String(error || 'Route load failed'));
  });
}

export function cancelRoutePending() {
  clearPendingTimer();
  showRouteFallback.value = false;
}

export function retryRouteContent() {
  routeContentError.value = null;
  window.location.reload();
}
